import { Step } from 'react-joyride';

export const arenaTutorialTourSteps: Step[] = [
  {
    target: '.play-btn',
    content: 'Welcome to the Arena Shop! Hre you can spend your Blood Gems on powerful rewards.',
    disableBeacon: true,
    placement: 'top',
    disableScrolling: true,
    title: 'Arena Shop',
  },
]; 